import { Injectable } from '@angular/core'

@Injectable()
export class WrapMiddleService {
  wrapString(s, length=14) {
    if (!s.includes(' ')) {
      return s
    }
    
    const reversed = s.reverse()
    let middle = Math.floor(s.length / 2)
    const before = reversed.lastIndexOf(' ', middle)
    const after = reversed.indexOf(' ', middle + 1)

    if (after == -1) {
      middle = before
    } else if (middle - before < after - middle) {
      middle = before
    } else {
      middle = after
    }

    return `${reversed.substr(0, middle)}\n${reversed.substr(middle + 1)}`.reverse()
  }
}
